import { MoreVerticalIcon } from '@assets/icons';
import { Banner } from '@components/banner';
import { IconButton } from '@components/button';
import { Group } from '@components/layout';
import { useModal } from '@components/modal';
import { Typography } from '@components/typography';
import { Menu, MenuItem, useTheme } from '@mui/material';
import { useCurrentWorkspace } from '@navigation/WorkspaceContext';
import { WorkspaceResourcesModal } from '@subsets/workspaces/landing/resources/WorkspaceResourcesModal';
import { MouseEvent, useState } from 'react';

export const DatasetsBanner = () => {
  const { palette } = useTheme();
  const {
    workspace: { name, organizationId, workspaceId },
  } = useCurrentWorkspace();
  const [anchorEl, setAnchorEl] = useState<Element>(null);
  const { showModal: showWorkspaceResourcesModal } = useModal({
    component: WorkspaceResourcesModal,
    componentProps: { organizationId, workspaceId, tab: 'gan' },
    modalProps: { title: `${name} resources`, sx: { maxWidth: '875px', width: '90%' } },
  });

  const handleMenuClick = (event: MouseEvent) => {
    setAnchorEl(event.currentTarget as Element);
  };
  const handleManageResourcesClick = () => {
    showWorkspaceResourcesModal();
    setAnchorEl(null);
  };

  return (
    <Banner>
      <Group
        color={palette.common.white}
        alignItems="center"
        justifyContent="flex-start"
        position="relative"
        gap={2}
        height="100%"
      >
        <Typography
          variant="subtitle1"
          color={palette.common.white}
          handleOverFlow
          sx={{ width: 'auto', maxWidth: '500px' }}
        >
          Datasets
        </Typography>
        <IconButton onClick={handleMenuClick} Icon={MoreVerticalIcon} size={20} />
        <Menu
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        >
          <MenuItem onClick={handleManageResourcesClick}>
            <Typography variant="caption2" data-cy="Workspaces-More-Dropdown-Resources">
              Manage workspace resources
            </Typography>
          </MenuItem>
        </Menu>
      </Group>
    </Banner>
  );
};
